<infm-page
  [title]="'i18n.mobile.page.deviceInformations'"
  [withBackAction]="true"
  [withPaddingInline]="false"
>
  <div class="content">
    @for (information of informations(); track information.name) {
      <div class="information">
        <div class="label">{{ information.name | translate }}</div>
        <div>{{ information.value | translate }}</div>
      </div>
    }
  </div>
</infm-page>
